/*
----- Axis Mega Menu ----- 
- Adds scroll bar to mega menu if the mega menu exceeds the view port.
- Adds support for when you scroll over an ebg group with an image to display that image in the level 2 container of the mega menu.
- wrap child groups to a new column with data-column-wrap
- group parent groups with no children together with data-group-childfree-submenus
- EBG support on for background on list item for default state or on reverse effect for hover state.

*/



var instances = {};

function getInstanceId(context) {
    if (!context) {
        AXISDebug.output(3,"Mega Menu: No context provided");
        return false;
    }
    let id = context.attr(expressSelectors()['mega-menu']['initialise']);
    if (!id) {
        AXISDebug.output(3,"Mega Menu: No Id found, has this element been initialised?");
        return false;
    } else {
        return id;
    }
}

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getContext(id) {
    return instances[id]['context'];
}

function setContainer(id, value) {
    return instances[id]['container'] = value;
}

function getContainer(id) {
    return instances[id]['container'];
}

function setGroupChildless(id, value) {
    return instances[id]['group-childless'] = value;
}

function getGroupChildless(id) {
    return instances[id]['group-childless'];
}

function setColumnWrap(id, value) {
    return instances[id]['column-wrap'] = value;
}

function getColumnWrap(id) {
    return instances[id]['column-wrap'];
}

function setPersistentEBGImages(id, value) {
    return instances[id]['persistent-ebg-images'] = value;  
}

function getPersistentEBGImages(id) {
    return instances[id]['persistent-ebg-images'];
}

// Initialise all instances ( normally called on page load ).
function initialiseAll() {
    // Get all instances.
    let elements = $('[' + expressSelectors()['mega-menu']['initialise'] + ']');
    // Loop through all instances.
    elements.each(function() {
        // Grab context.
        let context = $(this);
        // Initialise.
        let init = initialise(context);
    });
}

// Initialise a specific instance.
function initialise(context) {    
    let id = context.attr(expressSelectors()['mega-menu']['initialise']);
    // If this mega-menu has not been initialise then create new instance.
    if (!id) {
        id = generateId();
        // Assign id.
        context.attr(expressSelectors()['mega-menu']['initialise'], id);
        // Create a new instance.
        instances[id] = {};
        // Updat instance.
        setContext(id, context);
    } else {
        // Already initialised.
        return instances[id];
    }
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Mega Menu: Attempting to initialise mega menu", context);
    }
    // Make sure container is is assigned.
    if (!context.parent('[' + expressSelectors()['mega-menu']['container'] + ']').length) {
        context.wrap('<div class="mega-menu-container" ' + expressSelectors()['mega-menu']['container'] +'></div>');
    }
    // Get container context.
    let container = context.parent('[' + expressSelectors()['mega-menu']['initialise'] + ']');
    // Backwards compatibility, make sure initialise attribute is not on container.
    if (container.attr(expressSelectors()['mega-menu']['initialise']) != undefined) {
        container.removeAttr(expressSelectors()['mega-menu']['initialise']);
        container.attr(expressSelectors()['mega-menu']['container']);
    } else {
        container = context.parent('[' + expressSelectors()['mega-menu']['container'] + ']');
    }
    // Update instance.
    setContainer(id, container);
    // Group childless items together.
    let groupSubmenus = (context.attr(expressSelectors()['mega-menu']['group-childless']) != undefined);
    // Update instance.
    setGroupChildless(id, groupSubmenus);
    // Should we be limiting how many children gets shown in a column.
    let columnWrap = context.attr(expressSelectors()['mega-menu']['column-wrap']);

    let persistentImages = (context.attr(expressSelectors()['mega-menu']['persistent-ebg-images']) != undefined);
    setPersistentEBGImages(id, persistentImages);

    // Update instance.
    setColumnWrap(id, columnWrap);
    // Add Classes / Attributes.
    if (!context.hasClass('menu')) {-
        context.addClass('menu');
    }
    context.addClass('mega-menu');
    // Add class to parent container.
    context.find('li:has(" ul > li")').addClass('is-submenu-parent');
    // Add class to submenu container.
    context.find('li ul:not(.account-menu):has("li")').addClass('submenu').attr('data-submenu','');
    // Check if this dropdown has a account menu nested.
    context.find('li:has("ul.account-menu")').addClass('account-menu-container');
    // Add class to submenu items
    context.find('li ul li').addClass('is-submenu-item');

    // If configured group childless submenus together. 
    if (groupSubmenus) {
        groupChildlessSubmenus(id);
    }

    // If configured limit how many rows of children is displayed before wrapping.
    if (columnWrap != undefined) {
        doColumnWrap(id);
    }

    // Add markup.
    if (persistentImages) {
        persistentEBGImages(id);
    }

    addListeners(id);
    return instances[id];
}

function addListeners(id) {
    // Persistent EBG Images.
    let persistentImages = getPersistentEBGImages(id);
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Mega Menu: Persistent EBG Images is " + (persistentImages ? "enabled" : "disabled"), getContext(id));
    }
    // Get context.
    let context = getContext(id);
    context.find('> li').on('mouseenter', function() {
        // Submenu context.
        let submenu = $(this);
        // Find submenu.
        submenu = submenu.find('> [data-submenu]');
        // If submenu exists then check height, if over max then add scrolbar.
        if (submenu.length && !submenu.hasClass('overflow-scroll')) {
            // Dropdown max height.
            let maxHeight = 70;
            // Get active menu height.
            let height = submenu.outerHeight();
            // Convert px to vh.
            height = convertPxToVh(height);
            // If the dropdown height is greater than X amount of the users viewing area then display a scroller.
            if (height >= maxHeight) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Mega Menu: Dropdown height is greater than " + maxHeight + " vh, so adding scrollbar", submenu);
                }
            submenu.addClass('overflow-scroll');
            }
        }

        // Check if submenu has EBG image if so then scale the image column across all rows.
        if (submenu.length && submenu.find('[' + expressSelectors()['mega-menu']['group-image-context'] + ']').length) {
            // Select items that are being displayed + are not the EBG image itself.
            let menuItems = submenu.find('> li:not([' + expressSelectors()['mega-menu']['group-image-context'] + ']):not([style="display: none;"])');
            // Used to determine whether the next item is on the same row as the previous item.
            let position = "";
            // Max item height.-
            let max = 0;
            // How many rows to span.
            let rowCount = 0;
            // Get mega menu image.
            let image = submenu.find('[' + expressSelectors()['mega-menu']['group-image-context'] + ']');
            if (!image.length) {
                return false;
            }

            let rowsHeights = [];
            image.css('display', 'none');
            $.each(menuItems, function() {
                // Item contet.
                let item = $(this);
                // Get item height.
                let height = item.height();
                // Check if item is on same row.
                if (item.offset().top != position) {
                    // Override last item position.
                    position = item.offset().top;
                    // Reset max.
                    max = 0;
                    // Increment row count.
                    rowCount++;
                }
                if (!rowsHeights.hasOwnProperty(rowCount)) {
                    rowsHeights[rowCount] = [];
                }
                // Compare.
                max = Math.max(max, height);
    
                if (rowsHeights[rowCount] < max ) {
                    // Add heights to array.
                    rowsHeights[rowCount].push(max);
                }
            });

            // TODO: To support wrapping the content around the image this is what you need to do.
            // let span = 0;
            // Loop through array of heights deducting them from the image height to work out how many rows we need to span.
            // while ((imageHeight > 0) && rowsHeights[span + 1]) {
            //     imageHeight = (imageHeight - (parseInt(rowsHeights[span + 1]) + parseInt(gap[0])));
            //     span++;
            // }
            // menu.find('[' + expressSelectors()['mega-menu']['group-image-context'] + ']').css('grid-row', '1 / span ' + (rowsHeights.length == 2 ? 'last-line' : span));
            submenu.find('[' + expressSelectors()['mega-menu']['group-image-context'] + ']').css('grid-row', '1 / span ' + (rowsHeights.length + 1));
            // Re-display the image.
            image.css('display', '');
        }
    });

    // Skip over if persistent images is enabled.
    if (!persistentImages) {
        context.find('a').on('mouseenter', function() {
            // Grab context.
            let group = $(this);
            // Get the image src.
            let src = group.attr(expressSelectors()['mega-menu']['group-image-src']);
            // Fallbacks to the next parent with data-group-image defined.
            if (!src) {
                src = group.closest('[' + expressSelectors()['mega-menu']['group-image-src'] + ']');
            }
            if (src.length > 0) {
                if (AXISDebug.level() >= 4) {
                    AXISDebug.output(1,"Mega Menu: EBG image found", src);
                }
                // Find menu parent container.
                let container = "";
                // Find drop down menu. OLD WAY OF DOING THIS.
                if (!context.closest('.first-sub').length) {
                    // This is a parent li find its level 2.
                    container = group.parents('li').find(' > ul.first-sub');
                } else {
                    // Get the level 2 container.
                    container = group.parents('ul.first-sub');
                }
                // Fallback NEW WAY OF DOING THIS.
                if (!container.length) {
                    // Go up the DOM.
                    if (group.parents('[data-submenu]').length) {
                        container = group.parents('[data-submenu]').last();
                    } else if (group.next('[data-submenu]')) {
                        // Go down the DOM.
                        container = group.next('[data-submenu]');
                    }
                }
                // Check if container already has instance.
                let markup = container.find('[' + expressSelectors()['mega-menu']['group-image-context'] + ']');
                if (markup.length) {
                    markup.find('img').attr('src', src);
                } else {
                    // Create one.
                    // Markup for menu's ebg image.
                    markup = `
                        <li class="is-submenu-item menu-egb-image-container" ${expressSelectors()['mega-menu']['group-image-context']}>
                            <div class="image">
                                <img src="${src}" />
                            </div>
                        </li>
                    `;
                    // Add image to DOM.
                    container.prepend(markup);
                } 
            }
        });
    }
}

// In the Mega Menu dropd rop make the EBG image display above the group anchor, instead of making it's own column on hover, this functionality is only available on desktop.
function persistentEBGImages(id) {
    // Get context.
    let context = getContext(id);
    // Get persistant image flag.
    let persistentImages = getPersistentEBGImages(id);
    // Make sure it is enabled.
    if (!persistentImages) {
        return false;
    }
    // Lock this functionality to desktop only
    if (currentBreakpoint() < 3) {
        return false;
    }
    // Add class(s)
    context.addClass('persistent-ebg-images');    
    // Find all second level menu items that have an image.
    let items = context.find('> li > ul > li.is-submenu-item');
    // Lopp through items.
    items.each(function() {
        // Context.
        let item = $(this);
        // Get the image src.
        let src = item.find("> a[" + expressSelectors()['mega-menu']['group-image-src'] + ']');
        if (src.length) {
            src = src.attr(expressSelectors()['mega-menu']['group-image-src']);
        }

        // Fallbacks to parent.
        if (!src.length) {
            // Find parent.
            let parent = item.parents('li');
            // Get image src from parent anchor.
            src = parent.find("> a[" + expressSelectors()['mega-menu']['group-image-src'] + ']');
            if (src.length) {
                src = src.attr(expressSelectors()['mega-menu']['group-image-src']);
            }
        }
        // Prepend above.
        if (src.length) {
            item.find('> a').prepend(`<div class="image persistent-ebg-image" ${expressSelectors()['mega-menu']['persistent-image-container']}><img src="${src}" /></div>`);
        } else {
            if (AXISDebug.level() >= 4) {
                AXISDebug.output(1,"Mega Menu: Could not find image src for persistent EBG image", item);
            }
        }
    });
}



function groupChildlessSubmenus(id) {
    // Get context.
    let context = getContext(id);
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Mega Menu: Group childfree submenu's together", id);
    }
    // Group together submenu parents that don't have any children.            
    context.find('> li').each(function() {
        // Dropdown menus.
        let dropdown = $(this);
        // Group that others gets merged into, this gets reset every time a group with children has been detected.
        let firstItem = undefined;
        // Loop through dropdown menus.
        dropdown.find('> [data-submenu] > li').each(function() {
            // Group context.
            let group = $(this);
            // Whether we should clone this item.
            let doClone = false;
            // Has children.
            let children = (group.find("> ul").length);
            // Reset first item with no chilren.
            if (children) {
                firstItem = undefined;
            } else if (firstItem == undefined) {
                firstItem = group; 
            } else {
                doClone = true;
                firstItem.addClass('has-cloned-groups');
            }
            if (!children && doClone) {
                // Clone group.
                let cloned = group.clone();
                // Add class / attribute.
                cloned.addClass('mega-menu-childless-clone');
                cloned.attr('data-mega-menu-cloned-item', '');
                // Submenu we're going to merge too.
                let submenu = firstItem.find('> [data-submenu]');
                // Does column we're merging into have a submenu, if not create one.
                if (!submenu.length) {
                    // Update DOM.
                    firstItem.append('<ul class="childfree-parents-menu" data-submenu data-childfree-submenu></ul>');
                    // Put submenu into context.
                    submenu = firstItem.find('> [data-submenu]');
                    // Also clone first original parent and put into submenu.
                    submenu.append(firstItem.clone());
                    // Add classes / attribute(s).
                    firstItem.addClass('has-cloned-groups-parent');
                }
                // Add to submenu
                submenu.append(cloned);
                // Add classes / attribute(s).
                group.addClass('childfree-parent');
                group.attr('data-childfree-parent', '');
            }
        });
    });
}

function doColumnWrap(id) {
    // Get context.
    let context = getContext(id);
    // Get wrap count.
    let configuredColumnWrap = getColumnWrap(id);
    // Add fallback.. just incase.
    if (!configuredColumnWrap) {
        configuredColumnWrap = 7;
    } else {
        configuredColumnWrap = parseInt(configuredColumnWrap);
    }
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Mega Menu: Column wrap is configured, wrapping after " + configuredColumnWrap + " children", context);
    }
    // Work out childfree parent's wrap.
    let childfreeWrap = Math.floor((configuredColumnWrap / 2) + 1);

    // Add classes / attributes.
    context.css('--mega-menu-column-wrap', configuredColumnWrap);
    context.addClass('column-wrap');
    // Get submenu's.
    let submenus = context.find('> li > [data-submenu] > li > [data-submenu]');
    // Loop through submenu's.
    submenus.each(function() {
        // Column context.
        let submenu = $(this);
        // Get submenu items.
        let items = submenu.find('> li');
        // Get child count.
        let count = items.length;
        // Is this a menu of group parents.
        let childfreeParents = (submenu.attr('data-childfree-submenu') != undefined);
        // Override column wrap, due to typography being larger for parents.
        let columnWrap = (childfreeParents ? childfreeWrap : configuredColumnWrap);
        if (count > columnWrap) {
            // How many columns should we span?
            let spans = Math.ceil((count / columnWrap));
            // Find menu containing li.
            let container = submenu.parent('li');
            // Generate Id.
            let spanId = generateId();
            // Add class.
            container.addClass('mega-menu-column-span');
            // Loop over items.
            items.each(function(index) {
                // Item context.
                let item = $(this);
                 // Is this a view more item.
                let isViewMore = (item.find('> a[' + expressSelectors()['mega-menu']['view-more-link'] + ']').length);
                // If current column count hits column wrap limit.
                if ((index + 1) > columnWrap) {
                    // Build first / insert first additional column.
                    if (!container.next('li[data-column-span="' + spanId +'"]').length) {
                        $(buildColumnSpanMarkup(spanId, childfreeParents)).insertAfter(container);
                    }
                    // Find next avaliable column.
                    let colSpans = $('[data-column-span="' + spanId +'"]');
                    // Loop over additional columns.
                    colSpans.each(function(index) {
                        // Column context.
                        let column = $(this);
                        // Find submenu container.
                        let submenuContainer = column.find('> [data-submenu]');
                        // If column found that does not hit column wrap limit.
                        if (submenuContainer.children().length < columnWrap) {
                            submenuContainer.append(item.clone());
                        } else if (isViewMore) {
                            // Just tag it onto the last column regardless of count.
                            submenuContainer.last().append(item.clone());
                        } else {
                            // If no more column available then create one.
                            if (!index && !column.next('li[data-column-span="' + spanId +'"]').length) {
                                // New column context.
                                let newColumn = $(buildColumnSpanMarkup(spanId, childfreeParents)).insertAfter(column);
                                // Add item.
                                newColumn.find('> [data-submenu]').append(item.clone());
                            }
                        }
                    });
                    // Add classes / attribute(s) to original item.
                    item.addClass('cloned-to-seperate-row');
                    item.attr('data-column-cloned');
                }
            });
        }
    });
}

function buildColumnSpanMarkup(spanId, childFreeMenu = false) {
    return `
        <li data-column-span="${spanId}" class="is-submenu-item column-spanned">
            ${(!childFreeMenu ? "<a>...</a>" : "")}
            <ul class="column-span-submenu ${(childFreeMenu ? "childfree-parents-menu" : "")}" data-submenu ${(childFreeMenu ? "data-childfree-submenu" : "")}></ul>
        </li> 
    `
}

function destroyInstance(id) {

    // Get context.
    let context = getContext(id);
    // Is group childfree submenus configured.
    let groupChildess = getGroupChildless(id);
    // Check if this a persistent EBG image instance.
    let persistentImages = getPersistentEBGImages(id);
    if (AXISDebug.level() >=3 ) {
        AXISDebug.output(1,"Mega Menu: Attempting to destroy Mega Menu Instance", context);
    }
    // Remove Classes / attributes.
    context.removeClass('mega-menu');
    context.find('[data-submenu]').removeClass('overflow-scroll');
    context.find('li').removeClass("has-cloned-groups-parent has-cloned-groups childfree-parent cloned-to-seperate-row").removeAttr('data-childfree-parent');
    context.find('ul').removeClass('account-menu-container');
    // Unwrap.
    context.unwrap();
    if (groupChildess) {
        // Any megamenu classes / style.
        context.find('.mega-menu-column-span, .megamenu-column-cloned-span').removeAttr('style').removeClass('mega-menu-column-span megamenu-column-cloned-span');
        // Remove any cloned items.
        context.find('[data-mega-menu-cloned-item]').remove();
    }
    // Remove elements.
    context.find('[data-column-span]').remove();
    context.find('[data-childfree-submenu]').remove();
    // Remove style attribute.
    context.find('ul').removeAttr('style');
    context.find('li').css('display', '');
    // Remove any EBG Images.
    context.find('[' + expressSelectors()['mega-menu']['group-image-context'] +  ']').remove();
    // Remove instance Id from DOM.
    context.attr(expressSelectors()['mega-menu']['initialise'], '');
    // Remove Listeners.
    // Dropdown overflow.
    context.find('> li').off('mouseenter');
    // EBG Group Image swap.
    context.find('a').off('mouseenter');
    if (persistentImages) {
        // Find elements.
        context.find('[' + expressSelectors()['mega-menu']['persistent-image-container'] + ']').remove();
        // Remove class.
        context.removeClass('persistent-ebg-images');
    }
    // Kill memory instance.
    delete instances[id];
}


var AXISMegaMenu = $.AXISMegaMenu = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initialise(context);
    },
    destroy: (context) => {
        // Get Instance Id.
        let id = getInstanceId(context);
        if (!id) {
            return false;
        }
        return destroyInstance(id);
    }
}

export { AXISMegaMenu }